module.exports = __webpack_public_path__ + "static/media/4.finding-info.72a6084f.png";